import React, { useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Dialog from '@material-ui/core/Dialog'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import Typography from '@material-ui/core/Typography'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import SvgIcon from '@material-ui/core/SvgIcon'
import { ReactComponent as IconClose } from 'assets/icons/close.svg'
import useTranslation from 'hooks/useTranslations'
import useStyles from './styles'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const SaveSearch = props => {
  const { isOpen, onClose, onSubmit } = props

  const t = useTranslation()
  const classes = useStyles()

  const [name, setName] = useState('')

  const handleSubmit = event => {
    event.preventDefault()
    onSubmit(name)
  }

  const handleNameChange = e => {
    setName(e.target.value)
  }

  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('xs'))

  return (
    <Dialog
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      className={clsx(isSmall && classes.dialogXS)}
    >
      <DialogTitle
        disableTypography
        id="customized-dialog-title"
        className={classes.dialogTitle}
        onClose={onClose}
      >
        <Typography variant="h2">{t('search:new-search')}</Typography>

        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.dialogClose}
            onClick={onClose}
          >
            <SvgIcon component={IconClose} />
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent dividers className={classes.dialogContent}>
        <form className={classes.form} noValidate onSubmit={handleSubmit}>
          <FormControl fullWidth className={classes.formControl}>
            <InputLabel htmlFor="saveSearch" shrink>
              {t('search:new-search')}
            </InputLabel>
            <Input
              id="saveSearch"
              className={clsx(name && 'hasValue')}
              required
              autoFocus
              disableUnderline
              value={name}
              onChange={handleNameChange}
            />
          </FormControl>
          <Grid container justify="flex-end">
            <Grid item>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                className={classes.submit}
                disabled={!name}
              >
                {t('search:save-search')}
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  )
}

SaveSearch.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
}

export default SaveSearch
